export enum MachineSize {
    Small = 1,
    Medium = 2,
    Large = 3,
}

export const MachineSizeLabels = {
    [MachineSize.Small]: "Liten",
    [MachineSize.Medium]: "Medel",
    [MachineSize.Large]: "Stor"
}

export function getMachineSizeFromLabel(label: string): MachineSize | undefined {
    return (Object.entries(MachineSizeLabels)
        .find(([_, value]) => value === label)?.[0]) as MachineSize | undefined;
}